import React from 'react';
import { KoobPlaceholder } from '@koob/ui';

export default function TripVersionCompareLoading() {
  return (
    <>
      <KoobPlaceholder className="h-14 rounded-md w-full" />

      <div className="mt-5 flex flex-col space-y-5">
        <KoobPlaceholder className="h-44 rounded-md w-full" />
        <KoobPlaceholder className="h-32 rounded-md w-full" />
        <KoobPlaceholder className="h-32 rounded-md w-full" />
      </div>
    </>
  );
}
